import types from './types'

export default {
  setAffectedUserData(context, affectedUserData) {
    context.commit(types.SET_AFFECTED_USER, affectedUserData)
  },
  setSearchCriteria(context, payload) {
    context.commit(types.SET_SEARCH_CRITERIA_USER, payload)
  },
}
